import { useSelector } from '@xstate/react';
import { useRef } from 'react';
import { ActorRefFrom } from 'xstate';
import {
  EmployerFacilityForm,
  EmployerFacilityFormHandle,
} from '~/features/market/facility/EmployerFacilityForm';
import { EmployerFacilityValues } from '~/features/market/facility/types';
import { API_CALLS as FACILITY_API_CALLS } from '~/features/vault/facility/api';
import { Container, Footer, FormContent, Header } from '../components/Layout';
import { employerRegistrationView } from '../registration-view.machine';
import { EmployerInfoValues } from '../types';

interface Props {
  actorRef: ActorRefFrom<typeof employerRegistrationView>;
  defaultValues?: EmployerInfoValues;
  loading?: boolean;
}

export const EmployerFacilityValuesForm = ({ actorRef }: Props) => {
  const { facilityRef, employerFacility } = useSelector(actorRef, (state) => state.context);
  const formRef = useRef<EmployerFacilityFormHandle>(null);
  const onSubmitSuccess = (data: EmployerFacilityValues) => {
    actorRef.send({ type: 'ON_SUBMIT_EMPLOYER_FACILITY', data });
  };

  // [MCV-1667] Persist the in-progress (unsubmitted) values on Back so
  // re-entering this step doesn't discard what was typed.
  const handleBack = () => {
    const draft = formRef.current?.getValues();
    actorRef.send({ type: 'ON_PREVIOUS_PAGE', draft });
  };

  return (
    <Container>
      <Header
        title="Primary facility"
        subtitle="Please provide the following information about your primary facility to complete your registration."
      />

      <FormContent>
        <EmployerFacilityForm
          ref={formRef}
          onSubmitSuccess={onSubmitSuccess}
          facilityRef={facilityRef}
          facility={{
            facilityName: employerFacility.facilityName.value,
            facilityId: employerFacility.facilityId,
          }}
          defaultValues={employerFacility}
          loadFacilityOptions={FACILITY_API_CALLS.getPublic}
          isPrimary
          stickyActions={false}
        />
      </FormContent>

      <Footer handleBack={handleBack} loadingPercent={65} />
    </Container>
  );
};
